import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Button,
  Link,
  useColorModeValue,
} from '@chakra-ui/react';
import { useCookieConsent } from 'use-cookie-consent';

import { ENDPOINTS } from '@/settings/endpoints';
import { colors, zIndexMap } from '@/styles/ui.theme';

type Props = {
  children: React.ReactElement;
};

const CookieConsent = ({ children }: Props): React.ReactElement => {
  const { consent, acceptAllCookies } = useCookieConsent();

  const bgColor = useColorModeValue(colors.descomplica.gray['overlay-white-80'], 'gray.600');
  const linkColor = useColorModeValue(
    colors.descomplica.green.secondary,
    colors.descomplica.green.primary,
  );
  const buttonColor = useColorModeValue(
    colors.descomplica.green.primary,
    colors.descomplica.green.secondary,
  );

  if (!consent.firstParty) {
    return (
      <>
        {children}
        <Alert
          display='flex'
          justifyContent='space-between'
          position='sticky'
          bottom={0}
          alignItems='center'
          w='100%'
          status='info'
          zIndex={zIndexMap.hud}
          bg={bgColor}
        >
          <AlertIcon />
          <AlertTitle mr={2}>🍪</AlertTitle>
          <AlertDescription flexGrow={2}>
            Ao navegar neste site, você aceita os cookies que usamos para melhorar sua experiência.
            Aqui está nossa{' '}
            <Link color={linkColor} href={ENDPOINTS.privacyPolicy}>
              Política de Privacidade
            </Link>
          </AlertDescription>
          <Button bg={buttonColor} rounded='2xl' onClick={acceptAllCookies}>
            Ok, entendi
          </Button>
        </Alert>
      </>
    );
  }

  return children;
};

export default CookieConsent;
